export const metadataTagZonesColorArray = [
  "#FF4AEA",
  "#71D9FF",
  "#50FF00",
  "#FFAD07",
  "#B739FF",
  "#FF69B4",
  "#FFD700",
  "#FF6347",
  "#32CD32",
  "#FF1493",
  "#1E90FF",
  "#FF8C00",
  "#00FF7F",
  "#8A2BE2",
  "#00CED1",
  "#ffff00",
];
